angular.module('unergie.main')
.config((JSONFormatterConfigProvider) => {
    JSONFormatterConfigProvider.hoverPreviewEnabled = true
})
